module.exports = __webpack_public_path__ + "static/media/logo.cc4d208e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SportsAppBar/logo.svg
// module id = 507
// module chunks = 0